import { useEffect } from "react";

const useLayoutBootstrap = () => {
  useEffect(() => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }, []);
};

export default useLayoutBootstrap;
